module.exports = __webpack_public_path__ + "img/module9.c44b42a9.png";